























































import { Component, Emit, Model, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import 'vue-slider-component/theme/default.css'
import ScoringKeyEditor from "./ScoringKeyEditor.vue";

@Component({
    components: {ScoringKeyEditor}
})

export default class ScoringKeyEditorDialog extends Vue {

    @Model('change')
    scoringKeys!: any;

    @Prop({type: String})
    tooltip!: string;

    @Prop()
    name!: string;

    @Prop({default: false, type: Boolean})
    small: boolean;

    @Prop({default: false, type: Boolean})
    xSmall: boolean;

    @Prop()
    inheritedFromName!: string;

    @Prop()
    btnClass!: string;

    private scoringKeyDialog = false;
    private scoringKeysInternal: any = null;

    mounted() {
        this.scoringKeysInternal = this.scoringKeys;
    }

    @Watch('scoringKeys')
    scoringDefinitionChange() {
        this.scoringKeysInternal = this.scoringKeys;
    }

    @Emit()
    private submit(scoringKeys: any[]) {
        this.scoringKeyDialog = false;
        return scoringKeys
    }

    @Emit('delete')
    private deleteClick() {
        this.scoringKeyDialog = false;
        return null;
    }
}
